import { base64ToArrayBuffer } from './creditCheck';

/**
 * Reads a File/Blob and resolves with its content as a base64 data URL string
 * (e.g. "data:image/jpeg;base64,/9j/4AAQ...").
 */
export const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
  reader.readAsDataURL(file);
});

/**
 * A `blob:` object URL for base64 bytes, for handing a fetched document to `window.open`.
 *
 * Chrome has refused top-level navigation to a `data:` URL since Chrome 60: opening one gives
 * a new tab that never navigates and sits there blank white. Firefox still allows a
 * user-initiated `data:` PDF, which is why the same code can look fine there. A same-origin
 * `blob:` URL is navigable in both, so a document that arrived as base64 is handed over this
 * way rather than as `data:<type>;base64,...`.
 *
 * Returns '' when there is nothing to open, including a body `window.atob` rejects — the caller
 * then shows its own "unavailable" message rather than opening an empty tab.
 *
 * The URL is deliberately never revoked: the tab reads it after this returns and re-reads it if
 * the user reloads that tab, so revoking is what would break the document. It costs the size of
 * the file until the page is left, the same trade `saveByteArray` and `fetchFileAsBlob` make.
 */
export function base64ToObjectUrl(base64, contentType = 'application/octet-stream') {
  if (!base64) return '';
  try {
    const blob = new Blob([base64ToArrayBuffer(base64)], { type: contentType });
    return URL.createObjectURL(blob);
  } catch (e) {
    return '';
  }
}
